// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".originPreview[data-v-5b800b91]{max-width:150px}.matchResultRow[data-v-5b800b91]{display:flex;align-items:center;justify-content:space-between;gap:10px}.matchResultRow__item[data-v-5b800b91]{flex:1}.matchResultRow__item img[data-v-5b800b91]{width:100%}", ""]);
// Exports
module.exports = exports;
